import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Icons } from './Icons';

interface AdminLayoutProps {
  children: ReactNode;
}

const navItems = [
  { path: '/admin', label: 'Dashboard', icon: Icons.Dashboard },
  { path: '/admin/books', label: 'Books', icon: Icons.Books },
  { path: '/admin/users', label: 'Users', icon: Icons.Users },
];

export function AdminLayout({ children }: AdminLayoutProps) {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-stone-50 flex">
      {/* Sidebar */}
      <aside className="w-64 bg-white border-r border-stone-200 flex flex-col">
        <div className="p-6 border-b border-stone-200">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-md bg-stone-800 flex items-center justify-center">
              <span className="font-bold text-white text-sm">L</span>
            </div>
            <div>
              <span className="font-semibold text-stone-800 block leading-tight">Lynder</span>
              <span className="text-xs text-stone-500">Admin</span>
            </div>
          </Link>
        </div>

        <nav className="flex-1 p-4">
          <ul className="space-y-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path || 
                (item.path !== '/admin' && location.pathname.startsWith(item.path));
              
              return (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors text-sm ${
                      isActive 
                        ? 'bg-stone-100 text-stone-800 font-medium' 
                        : 'text-stone-500 hover:bg-stone-50 hover:text-stone-700'
                    }`}
                  >
                    <Icon />
                    <span>{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="p-4 border-t border-stone-200">
          <Link
            to="/"
            className="flex items-center gap-2 px-4 py-2 text-sm text-stone-500 hover:text-stone-700 hover:bg-stone-50 rounded-lg transition-colors"
          >
            <Icons.ChevronLeft />
            <span>Back to Site</span>
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        {children}
      </main>
    </div>
  );
}
